import { AcceleratedDepreciationItem } from '../types'

export const hasNegativeAcceleratedValue = (depreciationList: AcceleratedDepreciationItem[]) =>
  depreciationList.some(item => (item?.depreciation_amount as number) < 0)
